module.exports = __webpack_public_path__ + "static/ToolChain-20d53ac1453956d399cf239f43d3ddc5.png";